module.exports = __webpack_public_path__ + "media/papakike.bb968225.mp3";